import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Select, MenuItem, FormControl, InputLabel,
    Grid, Typography, Box, Radio, RadioGroup, FormControlLabel
} from '@mui/material';
import api_service from '../../../network/api_callbacks';
import { generatePublicUrlForFileInAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket';
import { resolveVideoPreview } from '../../../network/cloudflare_stream_service/CloudflareStream_api_callback';

const imageTypes = ['avatar', 'banner', 'thumbnail'];
const imageRatios = ['1:1', '16:9'];

export default function MediaSelectDialog({ open, onClose, onSubmit, selectedEntertainmentEntity }) {

    //console.log("selectedEntertainmentEntity : ", selectedEntertainmentEntity)
    const [mediaType, setMediaType] = useState('');
    const [imageType, setImageType] = useState('');
    const [aspectRatio, setAspectRatio] = useState('');
    const [selectedUrl, setSelectedUrl] = useState(null);
    const [mediaList, setMediaList] = useState([]);

    useEffect(() => {
        // if (selectedEntertainmentEntity?.multimedia) {
        //     const initializedMedia = selectedEntertainmentEntity.multimedia.map(item => ({
        //         ...item,
        //         isSelected: false
        //     }));
        //     setMediaList(initializedMedia);
        // }

        if (selectedEntertainmentEntity?._id && mediaList.length === 0) {
            getMultiMediaByEntityId(selectedEntertainmentEntity?._id);
        }

    }, [selectedEntertainmentEntity,mediaList?.length]);

    const getMultiMediaByEntityId = async (entityId) => {
        if (!entityId || typeof entityId !== "string" || entityId?.trim() === "") return null;
        try {
            const response = await api_service.getMultiMediaList(entityId);
            setMediaList(response?.[0]?.data || []);
            // setIsRefresh(false);
            console.log('📘 Multimedia Data:', response?.[0]?.data);
        } catch (error) {
            console.error('❌ Failed to fetch Multimedia:', error);
        }
    }

    const moveSelectedToTop = (multimedia) => {
        const selectedIndex = multimedia?.findIndex(item => item.isSelected);
        if (selectedIndex > 0) {
            const selectedItem = multimedia[selectedIndex];
            const rest = multimedia.filter((_, idx) => idx !== selectedIndex);
            return [selectedItem, ...rest];
        }
        return multimedia; // no change if already at top or not found
    };

    const handleSubmit = () => {
        const selectedMedia = mediaList?.find(item => item.isSelected);
        const multimedia = moveSelectedToTop(mediaList);
        onSubmit?.(selectedMedia,multimedia);
        onClose();
    };

    const filteredMedia = mediaList?.filter(media => {
        if (mediaType && media?.form !== mediaType) return false;
        if (mediaType === 'image') {
            if (imageType && media?.type !== imageType) return false;
            if (aspectRatio && media?.aspectRatio !== aspectRatio) return false;
        }
        return true;
    });

    const handleSelect = (index) => {
        const updated = mediaList.map((item, i) => ({
            ...item,
            isSelected: i === index // single-select logic
        }));
        setMediaList(updated);

        const selected = updated.find((item, i) => i === index);
        setSelectedUrl(selected?.url);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Select Media</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <FormControl fullWidth>
                        <InputLabel>Media Type</InputLabel>
                        <Select
                            value={mediaType}
                            label="Media Type"
                            onChange={(e) => {
                                setMediaType(e.target.value);
                                setImageType('');
                                setAspectRatio('');
                                setSelectedUrl(null);
                            }}
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="image">Image</MenuItem>
                            <MenuItem value="video">Video</MenuItem>
                            <MenuItem value="audio">Audio</MenuItem>
                        </Select>
                    </FormControl>

                    {mediaType === 'image' && (
                        <FormControl fullWidth>
                            <InputLabel>Image Type</InputLabel>
                            <Select
                                value={imageType}
                                label="Image Type"
                                onChange={(e) => {
                                    setImageType(e.target.value);
                                    setSelectedUrl(null);
                                }}
                            >
                                <MenuItem value="">All</MenuItem>
                                {imageTypes?.map(type => (
                                    <MenuItem key={type} value={type}>{type}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Box>

                {mediaType === 'image' && (
                    <FormControl sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>Aspect Ratio</Typography>
                        <RadioGroup
                            row
                            value={aspectRatio}
                            onChange={(e) => {
                                setAspectRatio(e.target.value);
                                setSelectedUrl(null);
                            }}
                        >
                            {imageRatios.map(r => (
                                <FormControlLabel key={r} value={r} control={<Radio />} label={r} />
                            ))}
                        </RadioGroup>
                    </FormControl>
                )}

                <Grid container spacing={2}>
                    {filteredMedia.map((media, index) => {
                        const isSelected = media.isSelected || false;

                        // Define fixed sizes per media type
                        const boxSizes = {
                            image: { width: 240, height: 180 },
                            video: { width: 240, height: 180 },
                            audio: { width: 240, height: 180 },
                        };

                        const { width, height } = boxSizes[media?.form] || { width: 200, height: 150 };

                        return (
                            <Grid key={`${media.url}-${index}`} xs="auto">
                                <Box
                                    onClick={() => handleSelect(mediaList.indexOf(media))}
                                    sx={{
                                        width,
                                        height,
                                        border: isSelected ? '2px solid #1976d2' : '1px solid #ccc',
                                        borderRadius: 2,
                                        padding: 1,
                                        cursor: 'pointer',
                                        transition: 'border 0.2s',
                                        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {media?.form === 'image' && (
                                        <img
                                            src={generatePublicUrlForFileInAWSS3Bucket(media.url)}
                                            alt={media.type}
                                            style={{ width: "90%", height: "90%", objectFit: "cover", borderRadius: 8 }}
                                        />
                                    )}
                                    {media?.form === 'video' &&
                                    (() => {
                                        const preview = resolveVideoPreview(media);
                                        if (preview.type === 'cloudflare' || preview.type === 'vimeo') {
                                            return (
                                                <iframe
                                                    title={`video-${media?.url || media?.cloudFlareVideoId}`}
                                                    src={preview.embedUrl}
                                                    width="90%"
                                                    height="90%"
                                                    style={{ border: 0, pointerEvents: "none", zIndex: 0 }}
                                                    frameBorder="0"
                                                    allow="fullscreen"
                                                />
                                            );
                                        }
                                        return (
                                            <video
                                                src={preview.url}
                                                style={{ width: "90%", height: "90%", borderRadius: 8, objectFit: "cover" , pointerEvents: "none", zIndex: 0 }}
                                            />
                                        );
                                    })()
                                    }
                                    {media?.form === 'audio' && (
                                        // <audio controls style={{width: "90%"}}>
                                        //     <source src={media.url} type="audio/mp3" />
                                        // </audio>
                                        <audio
                                        src={media?.url}
                                        controls
                                        seeking={false}
                                        style={{ width: "100%", height: "45px", pointerEvents: "none", zIndex: 0 }}
                                    />
                                    )}
                                    <Typography variant="caption" display="block" align="center" mt={1}>
                                        {media?.type || media?.type} {media?.aspectRatio && `(${media?.aspectRatio})`}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })}

                </Grid>

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="contained">Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={!mediaList.some(m => m.isSelected)}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}
